const HIDDEN_CSS_CLASS = 'spurit-hidden';
const CONTAINER_CLASS = 'spo-container';
const THEME_PRESTIGE_ID = 855;
const THEME_PRESTIGE_NAME = 'prestige';

export default class OriginalButton {
  /**
   * @type {HTMLElement}
   */
  #element;

  /**
   * @type {HTMLElement}
   */
  #parent;

  /**
   * @type {HTMLElement|null}
   */
  #nextSibling;

  /**
   * @type {{theme_id, theme_name}}
   */
  #settings;

  /**
   * @type {HTMLElement|null}
   */
  container;

  /**
   * @param {HTMLElement} element
   * @param settings
   */
  constructor(element, settings) {
    this.#settings = settings;
    this.#element = element;

    this.#saveElementPlacement();
    this.#wrapWithNewSpan();
  }

  /**
   * @returns {HTMLElement}
   */
  get element() {
    return this.#element;
  }

  /**
   * @returns {boolean}
   */
  /*get hiddenOrNotInDocument() {
    return this.notInDocument || this.hidden;
  }*/

  /**
   * @returns {boolean}
   */
  get hidden() {
    return this.container.classList.contains(HIDDEN_CSS_CLASS);
  }

  /**
   * @returns {boolean}
   */
  get notInDocument() {
    return !this.#element.parentNode;
  }

  /**
   * @returns {HTMLElement}
   */
  get parent() {
    return this.#parent;
  }

  /**
   *
   */
  hide() {
    if (this.notInDocument || this.hidden) {
      return;
    }
    this.container.classList.add(HIDDEN_CSS_CLASS);
  }

  /**
   *
   */
  /*removeFromDocument() {
    if (this.notInDocument) {
      return;
    }
    this.#saveElementPlacement();
    this.#parent.removeChild(this.#element);
  }*/

  /**
   *
   */
  restore() {
    if (this.container) {
      this.container.classList.remove(HIDDEN_CSS_CLASS);
    } else {
      const before = this.#parent.querySelector('.' + CONTAINER_CLASS);
      if (before) {
        this.#parent.insertBefore(this.#element, before);
      } else {
        this.#parent.insertBefore(this.#element, this.#nextSibling);
      }

      this.#wrapWithNewSpan();
    }
  }

  /**
   * @param {HTMLElement} newChild
   */
  insertBefore(newChild) {
      if (this.container) {
        this.container.parentNode.insertBefore(newChild, this.container);
      } else {
        this.#parent.insertBefore(newChild, this.#element);
    }
  }

  /**
   *
   */
  #saveElementPlacement() {
    this.#parent = this.#element.parentNode;
    this.#nextSibling = this.#element.nextSibling;
  }

  /**
   * Wrap original button with new container with hidden style, so if another application changes button or creates neighbour element - it will be hidden anyway.
   */
  #wrapWithNewSpan() {
    if (this.notInDocument) {
      return;
    }

    if (this.#element.parentNode.classList.contains(CONTAINER_CLASS)) {
      this.container = this.#element.parentNode;
      return;
    }

    if (this.#shouldWrap()) {
      this.container = document.createElement('span');
      this.container.classList.add(CONTAINER_CLASS);

      this.#parent.insertBefore(this.container, this.#element);
      this.container.appendChild(this.#element);
    } else {
      this.container = this.#element;
      this.#element.classList.add(CONTAINER_CLASS);
    }
  }

  /**
   * @return boolean
   */
  #shouldWrap() {
    if (!this.#settings.theme_id && !this.#settings.theme_name) {
      return true;
    }

    return this.#settings.theme_id === THEME_PRESTIGE_ID || this.#settings.theme_name.toLowerCase().includes(THEME_PRESTIGE_NAME);
  }
}